import graph from "@irati/utils/services/graph";
import { toString as walletQuery } from "./query/wallet";
import { toString as userWalletQuery } from "./query/UserWalletList";
import { toString as tenantWalletQuery } from "./query/TenantWalletList";
import { toString as giftUserWalletCreditMutation } from "./mutation/giftUserWalletCredit";
import { toString as sendCreditToUserMutation } from "./mutation/sendCreditToUser";
import walletErrorHandler from "../helpers/errors/walletErrorHandler";
var service = {
    get: function (userId, currency, options) {
        if (options === void 0) { options = {}; }
        return graph({ query: walletQuery, variables: { userId: userId, currency: currency } }, options).then(function (response) { return response.wallet; });
    },
    giftUserWalletCredit: function (userId, amount, currency, reason) {
        return graph({ query: giftUserWalletCreditMutation, variables: { userId: userId, amount: amount, currency: currency, reason: reason } }).catch(walletErrorHandler);
    },
    sendCreditToUser: function (senderId, receiverId, amount, currency) {
        return graph({ query: sendCreditToUserMutation, variables: { senderId: senderId, receiverId: receiverId, amount: amount, currency: currency } }).catch(walletErrorHandler);
    },
    userWalletList: function (userId) {
        return graph({ query: userWalletQuery, variables: { userId: userId } }).then(function (res) { return res.userWalletList; }).catch(walletErrorHandler);
    },
    tenantWalletList: function (tenantId) {
        return graph({ query: tenantWalletQuery, variables: { tenantId: tenantId } }).then(function (res) { return res.tenantWalletList; }).catch(walletErrorHandler);
    }
};
export var getWallet = service.get;
export var giftUserWalletCredit = service.giftUserWalletCredit;
export var sendCreditToUser = service.sendCreditToUser;
export var getUserWalletList = service.userWalletList;
export var getTenantWalletList = service.tenantWalletList;
export default service;
